var $c498ddcfdee7be70$exports = {};
$c498ddcfdee7be70$exports = {
    "more": `Vair\u{101}k vienumu`
};


export {$c498ddcfdee7be70$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
